import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Agenda from "../agenda/Agenda";
import { baseUrl } from "../../../resources/Constants";
import Unauthorized from "../general/Unauthorized";
import Loading from "../general/Loading";

function AgendaGeneral() {

    const [unidades, setUnidades] = useState([]);
    const [agendas, setAgendas] = useState([]);   
    const [nombreAgenda, setNombreAgenda] = useState();
    const [nombreUnidad, setNombreUnidad] = useState(null);

    // Estados para buscador de citas
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const searchTimeout = useRef(null);
    const searchRef = useRef(null);
    
    // Estados para validación de permisos
    const [hasPermission, setHasPermission] = useState(null);
    const [loggedIn, setLoggedIn] = useState(false);

    // Estados para controlar acordeones (todos sincronizados)
    const [acordeonesAbiertos, setAcordeonesAbiertos] = useState(false);

    // Función para abrir/cerrar todos los acordeones a la vez
    const toggleTodosAcordeones = () => {
        setAcordeonesAbiertos(!acordeonesAbiertos);
    };

    const [unidad, setUnidad] = useState();
    const [estadosCita, setEstadosCita] = useState([]);
    const [agenda, setAgenda] = useState();
    const [estadoAgendaProfesional, setEstadoAgendaProfesional] = useState('visible');
    const [selectedDate, setSelectedDate] = useState();
    const [toastMsg, setToastMsg] = useState();

    useEffect(()=>{
        // Validación de permisos
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        // Validación híbrida de permisos (nuevo + legacy)
        let tienePermiso = false;
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'verAgenda');
        } else if (userdata.up && userdata.up.includes('verAgenda')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // 🔒 Usar axios que ya tiene el token configurado
        const requestAgendas = axios.get('/agendas-usuario')
            .then(response => {
                setLoggedIn(true);
                return response.data;
            })
            .catch(error => {
                console.log('Error cargando agendas:', error);
                setLoggedIn(true);
                return [];
            });

        const requestUnidades = axios.get('/unidades-atencion')
            .then(response => response.data)
            .catch(error => {
                console.log('Error cargando unidades:', error);
                return [];
            });

        const requestEstadosCita = axios.get('/estados-cita')
            .then(response => response.data)
            .catch(error => {
                console.log('Error cargando estados:', error);
                return [];
            });

       const result = Promise.all([requestAgendas, requestUnidades, requestEstadosCita]);

result.then(
    function(response) {
        setAgendas(response[0]);
        setUnidades(response[1]);
        setEstadosCita(response[2]);
    }
);
    },[]);


    useEffect(() => {
        //console.log('Unidad: '+unidad);
    },[unidad]);


    const asignarAgenda = (id, nombre) => {
        console.log('asignarAgenda llamada con:', { id, nombre });
        setAgenda(id);
        setNombreAgenda(nombre);
    }

    const [botonProfesionalesActivo, setBotonProfesionalesActivo] = useState('activo');
    const [botonRecursosActivo, setBotonRecursosActivo] = useState('');

  function handleTipoCalendar(tipocal) {
    // ✅ CORRECCIÓN: Usar la nueva función
    asignarAgenda(null, null);
    
    setUnidad(null);
    setNombreUnidad(null);
    document.getElementById('agenda').value = ""; // ← También cambiar el ID
    document.getElementById('unidad').value = "";
    tipocal=='profesional' ? setVerProfesionales(true) : setVerProfesionales(false);

    if (tipocal=="profesional") {
        setBotonProfesionalesActivo('activo');
        setBotonRecursosActivo('');
    }
    else if (tipocal=="recursos") {
        setBotonProfesionalesActivo('');
        setBotonRecursosActivo('activo');
    }
}

    function handleCitaAgendada() {

        if (localStorage.getItem('msgtoast')) {
            let msg = localStorage.getItem('msgtoast');
            localStorage.removeItem('msgtoast');
            setToastMsg(msg);
        }
    }

    // Búsqueda de citas con debounce
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (searchTimeout.current) {
            clearTimeout(searchTimeout.current);
        }

        if (value.length < 3) {
            setSearchResults([]);
            setShowResults(false);
            setSearchLoading(false);
            return;
        }

        setSearchLoading(true);
        searchTimeout.current = setTimeout(() => {
            axios.get('/buscar-citas-paciente', { params: { q: value } })
                .then(response => {
                    setSearchResults(response.data);
                    setShowResults(true);
                    setSearchLoading(false);
                })
                .catch(error => {
                    console.log('Error buscando citas:', error);
                    setSearchResults([]);
                    setShowResults(false);
                    setSearchLoading(false);
                });
        }, 300);
    };

    // Seleccionar resultado de búsqueda: navegar fecha + seleccionar agenda
    const handleSelectSearchResult = (resultado) => {
        asignarAgenda(resultado.agenda_id, resultado.agenda_nombre);
        setSelectedDate(resultado.fecha_cita);

        // Actualizar el select de agenda visualmente
        const selectAgenda = document.getElementById('agenda');
        if (selectAgenda) {
            selectAgenda.value = resultado.agenda_id;
        }

        // Limpiar buscador
        setSearchTerm('');
        setSearchResults([]);
        setShowResults(false);
    };

    // Cerrar resultados al hacer click fuera
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (searchRef.current && !searchRef.current.contains(e.target)) {
                setShowResults(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const [verProfesionales, setVerProfesionales] = useState(true);


                

// Protección de ruta estándar
if (hasPermission === false) {
    return <Unauthorized />;
}

if (!loggedIn) {
    return <Loading />;
}

return  <div className="hold-transition">
                <Header />
                <Aside activelink="calendar" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item">
                                        <div className="col-sm-2" style={{display:'flex',alignItems:'center'}}>
                                            <h1 className="m-0">Agenda</h1>
                                        </div>
                                        </li>
                                    </ol>

                                </div>
                            </div>
<div className="row mb-3">

<div className="col-sm-5 grupo-encabezado-agenda">
 <div className="card-header">
<h4 className="card-title w-100">
 <button 
    type="button"
    className="btn btn-link d-block w-100 text-left p-0"
    onClick={toggleTodosAcordeones}
    aria-expanded={acordeonesAbiertos}
    style={{ textDecoration: 'none', color: 'inherit' }}
>
Calendarios
</button>
</h4>
</div>
<div className={`collapse ${acordeonesAbiertos ? 'show' : ''}`}>
<div className="card-body">
    


  <div className={'form-group '+ (verProfesionales ? '' : 'hide') }>
  <label htmlFor="profesional">Agenda</label>
  <select name="agenda" className="col-sm-10 form-control" id="agenda" 
    onChange={(e) => {
        console.log('Agenda seleccionada:', e.target.value, e.target.options[e.target.selectedIndex].text);
        asignarAgenda(e.target.value, e.target.options[e.target.selectedIndex].text);
    }}>
    <option value="">Seleccionar agenda...</option>
    {agendas.map((agenda) => <option key={agenda.id} value={agenda.id}>{agenda.nombre}</option>)}
</select>

<label htmlFor="appointmentTime">Fecha</label>
<input type="date" className="col-sm-10 form-control" onChange={(e) => setSelectedDate(e.target.value)} />
</div>

<div className="form-group">
<label htmlFor="unidadFiltro">Unidad de atención</label>
<select name="unidadFiltro" className="col-sm-10 form-control" id="unidadFiltro" 
    onChange={(e) => {
        setUnidad(e.target.value || null);
        const selectedOption = e.target.options[e.target.selectedIndex];
        setNombreUnidad(e.target.value ? selectedOption.text : null);
    }}>
    <option value="">Todas las unidades</option>
    {unidades.map((uni) => <option key={uni.id} value={uni.id}>{uni.nombre_unidad}</option>)}
</select>
</div>

</div>

</div>
</div>

<div className="col-sm-5 grupo-encabezado-agenda">
 <div className="card-header">
<h4 className="card-title w-100">
 <button 
    type="button"
    className="btn btn-link d-block w-100 text-left p-0"
    onClick={toggleTodosAcordeones}
    aria-expanded={acordeonesAbiertos}
    style={{ textDecoration: 'none', color: 'inherit' }}
>
 Vistas
</button>
</h4>
</div>
<div className={`collapse ${acordeonesAbiertos ? 'show' : ''}`}>
<div className="card-body">

<label>Cambiar Vista</label>
<div className="form-group botones-grupo-encabezado-agenda">
<Link to="/agenda-recursos" className="col-sm-5 btn btn-primary">Agendas <i className="fas fa-search"></i></Link>
{' '}
<Link to="/agenda-unidades" className="col-sm-5 btn btn-primary">Unidades <i className="fas fa-search"></i></Link>
</div>

 </div>
</div>
</div>



















<div className="col-sm-5 grupo-encabezado-agenda">
 <div className="card-header">
<h4 className="card-title w-100">
 <button 
    type="button"
    className="btn btn-link d-block w-100 text-left p-0"
    onClick={toggleTodosAcordeones}
    aria-expanded={acordeonesAbiertos}
    style={{ textDecoration: 'none', color: 'inherit' }}
>
 Estados de la Agenda
</button>
</h4>
</div>
<div className={`collapse ${acordeonesAbiertos ? 'show' : ''}`}>
<div className="card-body">
    
<div id="external-events" className="estados-cita-box-compact">
{
    estadosCita.map((estadoCita) => 
        <div key={estadoCita.id} className="estado-cita-badge" style={{backgroundColor: estadoCita.color}}>
            <span className="estado-cita-text">{estadoCita.nombre}</span>
        </div>
    )
}
</div>
 </div>
</div>
</div>

</div>

{/* Buscador de citas por paciente - misma fila flex que los cuadros */}
<div className="row mb-3" style={{display: 'flex', flexWrap: 'wrap'}}>
    <div className="grupo-encabezado-agenda" ref={searchRef} style={{position: 'relative', flexBasis: 'calc(100% - 45px)', padding: '8px 10px'}}>
        <div className="form-group" style={{marginBottom: 0}}>
            <input 
                type="text" 
                className="form-control form-control-lg" 
                placeholder="Buscar paciente por nombre..." 
                value={searchTerm}
                onChange={handleSearchChange}
                style={{fontSize: '16px'}}
            />
            {searchLoading && (
                <small className="text-muted"><i className="fas fa-spinner fa-spin"></i> Buscando...</small>
            )}
        </div>
        {showResults && (
            <div style={{
                position: 'absolute', 
                top: '100%', 
                left: 0, 
                right: 0, 
                zIndex: 1050, 
                backgroundColor: '#fff', 
                border: '1px solid #ddd', 
                borderRadius: '4px', 
                maxHeight: '300px', 
                overflowY: 'auto',
                boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
            }}>
                {searchResults.length === 0 ? (
                    <div style={{padding: '10px 15px', color: '#999'}}>No se encontraron citas para este paciente</div>
                ) : (
                    searchResults.map((r) => (
                        <div 
                            key={r.id_cita} 
                            onClick={() => handleSelectSearchResult(r)}
                            style={{
                                padding: '8px 15px', 
                                cursor: 'pointer', 
                                borderBottom: '1px solid #eee',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                        >
                            <div>
                                <strong>{r.primer_nombre} {r.segundo_nombre || ''} {r.primer_apellido} {r.segundo_apellido || ''}</strong>
                                <br/>
                                <small className="text-muted">{r.fecha_cita} - {r.agenda_nombre}</small>
                            </div>
                            <span className="badge badge-info">{r.estado_cita}</span>
                        </div>
                    ))
                )}
            </div>
        )}
    </div>
</div>

                            <div className="row mb-3">

                                <div className="col-sm-3">

                                    <div className={'form-group '+ (verProfesionales ? 'hide' : '') }>
                                        <label htmlFor="profesional">Unidad de atención</label>
                                        <select name="unidad" className="form-control" id="unidad" onChange={(e) => {
                                            setUnidad(e.target.value || null);
                                            const selectedOption = e.target.options[e.target.selectedIndex];
                                            setNombreUnidad(e.target.value ? selectedOption.text : null);
                                        }}>
                                            <option></option>
                                            {
                                                unidades.map((uni) => <option key={uni.id} value={uni.id}>{uni.nombre_unidad}</option>)
                                            }
                                        </select>
                                   
                                    </div>

                                </div>
                            </div>
                            

                        </div>
                    </div>
                    {/* Resumen de agenda y unidad seleccionada */}
                    {(nombreAgenda || nombreUnidad) && (
                        <div className="container-fluid" style={{padding: '6px 15px', marginBottom: '4px'}}>
                            <span style={{fontSize: '14px', color: '#495057'}}>
                                {nombreAgenda && (
                                    <><i className="fas fa-calendar-alt" style={{marginRight: '5px', color: '#6c757d'}}></i>{nombreAgenda}</>
                                )}
                                {nombreAgenda && nombreUnidad && <span style={{margin: '0 8px', color: '#adb5bd'}}>|</span>}
                                {nombreUnidad && (
                                    <><i className="fas fa-hospital" style={{marginRight: '5px', color: '#6c757d'}}></i>{nombreUnidad}</>
                                )}
                            </span>
                        </div>
                    )}
                    <section className="content" >
                        <div className="row">
                            <div className="col-md-12">

                                <div className="container-fluid">
                                    <div className={'agenda-profesional '+estadoAgendaProfesional}>
                                       <Agenda
    profesionalAsignado={agenda}  // ← Mantener nombre por compatibilidad
    usuarioAsigna={agenda}        // ← Mantener nombre por compatibilidad  
    nombreProfesionalAsignado={nombreAgenda}  // ← Mantener nombre
    nombreUsuarioAsigna={nombreAgenda}        // ← Mantener nombre
    unidad={unidad}
    bloquearProfesional={false}
    eventOverlap={false}
    irAFecha={selectedDate}
    citaAgendada={handleCitaAgendada}
/>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </section>
                </div>
                <Footer showToast={false} delay={0} message={toastMsg} />
            </div>

}
export default AgendaGeneral;